// document.addEventListener("DOMContentLoaded", function() {
//     // Run only on mobile
//     if (window.innerWidth <= 768) {
//       document.querySelectorAll(".grid-link__title a").forEach(function(el) {
//         let words = el.innerText.trim().split(" ");
//         if (words.length > 8) {
//           el.innerText = words.slice(0, 8).join(" ") + "...";
//         }
//       });
//     }
//   });

  //laptop size
  document.addEventListener("DOMContentLoaded", function () {
  if (typeof window.laptopSizeData === "undefined" || !window.laptopSizeData.hasBags) return;

  const laptopSizeEl = document.getElementById("laptop-size-text");

  function updateLaptopSize(variant) {
    if (!variant || !laptopSizeEl) return;

    // Check size based on exact title
    if (variant.title === "S") {
      laptopSizeEl.textContent = window.laptopSizeData.small;
    } else if (variant.title === "L") {
      laptopSizeEl.textContent = window.laptopSizeData.large;
    } else {
      laptopSizeEl.textContent = "NA";
    }
  }

  // Listen for Shopify variant change
  document.addEventListener("variant:change", function (e) {
    if (e.detail && e.detail.variant) {
      updateLaptopSize(e.detail.variant);
    }
  });

  // Set default on page load
  if (window.Shopify && window.Shopify.theme?.product?.variants?.length) {
    updateLaptopSize(window.Shopify.theme.product.variants[0]);
  }
});
